import { setHours as setHoursFns } from 'date-fns';

export default function setHours(date: Date, hour: number): Date {
  return setHoursFns(date, hour);
}
